<script setup lang="ts">
import type { ImageType } from "@/types";

type PropsType = {
  content: {
    image: ImageType;
    content: string;
  };
};

const props = defineProps<PropsType>();
const image = ref(props?.content?.image);
const content = ref(props?.content?.content);
</script>

<template>
  <div class="image_content">
    <div class="container">
      <div class="image_content-inner">
        <div class="image">
          <img :src="useStrapiMedia(image?.url)" alt="" />
        </div>

        <div class="content rich-text">
          <BaseRichText :content="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.image_content {
  @apply py-5;

  &-inner {
    @apply flex flex-col gap-4;

    @screen lg {
      @apply flex-row;
    }

    .image,
    .content {
      @apply flex-1;
    }

    .image {
      @apply order-last;
    }

    .content {
      :deep() {
        p {
          @apply text-sm;
        }
      }
    }
  }
  // @apply;
}
</style>
